// extracted by mini-css-extract-plugin
export var assigneeBadge = "_hk-0";
export var assigneeDetails = "_hk-1";
export var assigneeInfo = "_hk-2";
export var dropdownContainer = "_hk-4";
export var dropdownImage = "_hk-5";
export var editAssigneeInfo = "_hk-3";
export var editAssigneeModalContainer = "_hk-6";
export var hidden = "_hk-8";
export var input = "_hk-7";